import { meEndpoints } from './me';
import { authEndpoints } from './auth';
import { progressEndpoints } from './progress';
import { staticContentEndpoints } from './static-content';
import { quizEndpoints } from './quiz';
import { practiceEndpoints } from './practice';
import { uiPrefsEndpoints } from './ui-prefs';
import { adminEndpoints } from './admin';

/**
 * Single api surface · `api.me.get()` · `api.progress.patchTicket(...)` etc.
 * Matches edge-function groups 1:1 in domain naming.
 */
export const api = {
  me: meEndpoints,
  auth: authEndpoints,
  progress: progressEndpoints,
  staticContent: staticContentEndpoints,
  quiz: quizEndpoints,
  practice: practiceEndpoints,
  uiPrefs: uiPrefsEndpoints,
  admin: adminEndpoints,
};

export {
  meEndpoints,
  authEndpoints,
  progressEndpoints,
  staticContentEndpoints,
  quizEndpoints,
  practiceEndpoints,
  uiPrefsEndpoints,
  adminEndpoints,
};
